import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListProfessionalLevel from "./List";
import ProfessionalLevelPopup from "./PopUp";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Breadcrumb from "../../../../utils/BreadCrumb";

export default function ProfessionLevelAndFee(props) {
  const location = useLocation();
  const isCreateMode = location.pathname.endsWith("/profession-levels-&-fees/create");
  const isEditMode = location.pathname.includes("/profession-levels-&-fees/edit");

  const commonItems = [{ label: 'PROFESSION LEVELS & FEES', link: '/dashboard/profession-levels-&-fees' }];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: 'EDIT', link: '' }]
    : isCreateMode
    ? [...commonItems, { label: 'CREATE', link: '' }]
    : commonItems;

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const [addEditPopup, setAddEditPopup] = useState({
    open: false,
  });
  const dispatch = useDispatch();
  const [updateProfessionList, setUpdateProfessionList] = useState(false);
  const token = localStorage.getItem("token");
  const [professionList, setProfessionList] = useState([]);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create")
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
  }, [location]);

  const fetchProfessionList = () => {
    setLoading({ ...loading, listData: true });
    axios
      .get("/dashboard/profession-level", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const response = res?.data?.data;
        setProfessionList(response);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      })
      .finally(() => {
        setLoading({ ...loading, listData: false });
      });
  };

  useEffect(() => {
    fetchProfessionList();
  }, [updateProfessionList]);

  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(
          `/dashboard/profession-level/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setUpdateProfessionList((prev) => !prev);
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(setAppError({ msg: err.message }));
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(setAppError({ msg: err?.response?.data.message }));
          }
        }
      }
    }
  };

  const addData = () => {
    setAddEditPopup((p) => ({
      ...p,
      open: true,
      mode: "create",
    }));
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

    
    useEffect(() => {
      dispatch(setBreadCrumb(breadcrumbItems))

    }, [location.pathname]);

  return (
    <>
      {/* <Breadcrumb items={breadcrumbItems} /> */}
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      {addEditPopup.open && (
        <ProfessionalLevelPopup
          showPromptElement={addEditPopup}
          setShowPromptElement={setAddEditPopup}
          setUpdateProfessionList={setUpdateProfessionList}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        <>
          <ListProfessionalLevel
            professionList={professionList}
            deleteData={setShowPromptElement}
            loading={loading?.listData}
            column={4}
            setAddEditPopup={setAddEditPopup}
            addData={addData}
            listLoading={loading.listData}
          />
        </>
      </div>
    </>
  );
}
